export default {
  particleChartlet: {
    title: 'パーティクルテクスチャ',
  },
  particlePlay: {
    title: '再生設定',
    cycleIndex: 'ループ回数',
    startBtn: '再生開始',
    stopBtn: '再生停止',
    sequence: '回',
    LoopPlayback: 'ループ再生',
    playOnAwake: '自動再生',
  },
  particleSetting: {
    particleParameter: 'パーティクルパラメータ',
    particleDynamicParameter: '物理パラメータ',
    overLifespan: 'パーティクルのグラデーションパラメータ',
    changingCurve: '変化曲線',
    zoneType: {
      title: 'エミッション領域',
      detail:
        '4つのタイプに対応：Zone.POINT（点）、Zone.LINE（直線）、Zone.CIRCLE（円）、Zone.RECTANGLE（四角形）',
    },
    zoneLength: {
      title: '領域の長さ',
      detail: '直線エミッション領域の長さ',
    },
    zoneRotation: {
      title: '領域の回転',
      detail: '直線エミッション領域の回転角度',
    },
    zoneRadius: {
      title: '領域の半径',
      detail: '円エミッション領域の半径',
    },
    zoneWidth: {
      title: '領域の幅',
      detail: '矩形エミッション領域の幅',
    },
    zoneHeight: {
      title: '領域の高さ',
      detail: '矩形エミッション領域の高さ',
    },
    edgeEmission: {
      title: 'エミッションエッジ',
      detail: 'Edge Emission',
    },
    emissionSpace: {
      title: 'エミッションスペース',
      detail: 'ローカル座標系（Local）またはワールド座標系（World）',
    },
    quantity: {
      title: 'パーティクルの数',
      detail: 'エミッションごとのパーティクルの数',
    },
    frequency: {
      title: '発生頻度',
      detail: 'パーティクルの発生間隔',
    },
    startScaleMin: {
      title: '最小パーティクルサイズ',
      detail: '生成されるパーティクルの最小サイズと元のパーティクルの比率',
    },
    startScaleMax: {
      title: '最大パーティクルサイズ',
      detail: '生成されるパーティクルの最大サイズと元のパーティクルの比率',
    },
    startAlphaMax: {
      title: '最大透明度',
      detail: '生成されるパーティクルの最大透明度',
    },
    startAlphaMin: {
      title: '最小透明度',
      detail: '生成されるパーティクルの最小透明度',
    },
    startRotationMin: {
      title: '最小回転角度',
      detail: '生成されるパーティクルの最小回転角度',
    },
    startRotationMax: {
      title: '最大回転角度',
      detail: '生成されるパーティクルの最大回転角度',
    },
    startVelocityMin: {
      title: '最小速度',
      detail: '生成されるパーティクルの最小速度',
    },
    startVelocityMax: {
      title: '最大速度',
      detail: '生成されるパーティクルの最大速度',
    },
    lifespanMin: {
      title: '最小サイクル',
      detail: '生成されるパーティクルの最小サイクル',
    },
    lifespanMax: {
      title: '最大サイクル',
      detail: '生成されるパーティクルの最大サイクル',
    },
    gravityX: {
      title: '速度加算X',
      detail: 'X方向の重力',
    },
    gravityY: {
      title: '速度加算Y',
      detail: 'Y方向の重力',
    },
    maxParticles: {
      title: '最大パーティクル数',
      detail:
        'パーティクル数がこの値を超えると、パーティクルのエミッションが停止します',
    },
    delay: {
      title: 'エミッション遅延',
      detail: '遅延して発生させるパーティクルの時間',
    },
    blendMode: {
      title: 'ブレンドモード',
      detail: 'Blend Mode',
    },
    startColor: {
      title: 'テーマカラー',
      detail: 'パーティクルが生成された時の色',
    },
    startColorVariation: {
      title: 'テーマカラーフロート',
      detail: 'パーティクル生成時のカラーフロート',
    },
    endColor: {
      title: '最後の色',
      detail: 'パーティクル消滅後の色',
    },
    endColorVariation: {
      title: '最後の色のフロート',
      detail: 'パーティクル消滅後の色',
    },
    angleMin: {
      title: '最小放射角度',
      detail: '生成されるパーティクルの最小放射角度',
    },
    angleMax: {
      title: '最大発射角度',
      detail: '最大放射角度',
    },
    angularVelocityMin: {
      title: '最小の角速度',
      detail: '生成されるパーティクルの最小角速度',
    },
    angularVelocityMax: {
      title: '最大の角速度',
      detail: '生成されるパーティクルの最大角速度',
    },
    colorCurve: {
      title: '色のライフサイクル',
      detail: 'パーティクルカラーのライフサイクルカーブ',
    },
    alphaCurve: {
      title: '透明度のライフサイクル',
      detail: 'パーティクルの透明度のライフサイクルカーブ',
    },
    scaleCurve: {
      title: 'サイズのライフサイクル',
      detail: 'パーティクルのサイズのライフサイクルカーブ',
    },
    velocityCurve: {
      title: '速度のライフサイクル',
      detail: 'パーティクルの速度のライフサイクルカーブ',
    },
    angularVelocityCurve: {
      title: '角速度のライフサイクル',
      detail: 'パーティクルの角速度のライフサイクルカーブ',
    },
  },
}
